// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MemberLibraryPage-module__bookShelf--i61Yk {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 32px 0;
  gap: 32px;
}`, "",{"version":3,"sources":["webpack://./src/pages/MemberLibraryPage/MemberLibraryPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX","sourcesContent":[".bookShelf {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  padding: 32px 0;\n  gap: 32px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookShelf": `MemberLibraryPage-module__bookShelf--i61Yk`
};
export default ___CSS_LOADER_EXPORT___;
